import React, {useState, useEffect} from 'react';

const CatalogueFilterSliderCircle = ({className, sliderStep, minValue, maxValue, position, setPosition, setColoredLinePos}) => {
  const [offset, setOffset] = useState(0);
  const [currentPosition, setCurrentPosition] = useState(position);

  let circleRef = null;
  let blankElement = document.createElement('div');

  useEffect(() => {
    setCurrentPosition(position)
  }, [position]);

  const handleDragStart = event => {
    setOffset(circleRef.parentElement.getBoundingClientRect().left +
      (event.clientX - event.currentTarget.getBoundingClientRect().left));

    event.dataTransfer.setDragImage(blankElement, 0, 0);
  };

  const handleDragOver = event => {
    event.preventDefault();
    const positionInCss = Math.floor(event.clientX - offset);

    let newPosition = (positionInCss * sliderStep / 100).toFixed() * 100;

    if (newPosition < minValue) {
      newPosition = minValue;
    }

    if (newPosition > maxValue) {
      newPosition = maxValue
    }

    setCurrentPosition(newPosition);
    setColoredLinePos((newPosition / sliderStep).toFixed())
  };

  const handleDragEnd = event => {
    event.preventDefault();

    setPosition(currentPosition);
  };

  const circleStyle = {
    left: `${currentPosition / sliderStep}px`
  };

  return (
    <div ref={div => circleRef = div}
         draggable
         className={className}
         style={circleStyle}
         onDragOver={handleDragOver}
         onDragStart={handleDragStart}
         onDragEnd={handleDragEnd}/>
  )
};

export default CatalogueFilterSliderCircle
